"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "9ac2804",
    "raw": "v2.10.0",
    "semverString": "2.10.0"
};
//# sourceMappingURL=version.js.map